// HeaderLogIn.js - Main component
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import api from '../services/api';
import '../styles/HeaderLogIn.css';
import getProfileImageUrl from '../utils/getProfileImageUrl';

function HeaderLogIn() {
  const [userData, setUserData] = useState({ username: '', profilePhoto: '' });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Fetch user data
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('Token alınamadı');
      navigate('/login');
      return;
    }

    api.get('/header/headerInfo', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(response => {
        setUserData({
          username: response.data.username,
          profilePhoto: getProfileImageUrl(response.data.profile_image_url)
        });
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          navigate('/login');
        }
      });
  }, [navigate]);

  // Add padding for mobile footer
  useEffect(() => {
    if (isMobile) {
      const content = document.querySelector('main') || document.querySelector('.page-container') || document.body;
      const existingGap = document.querySelector('.mobile-footer-gap');
      
      if (!existingGap) {
        const gapDiv = document.createElement('div');
        gapDiv.className = 'mobile-footer-gap';
        content.appendChild(gapDiv);
      }
    }
  }, [isMobile]);

  // Common functions and data that both components will need
  const userId = localStorage.getItem('userId');
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    navigate('/');
  };

  const categories = [
    { id: 1, name: 'Aksiyon' },
    { id: 2, name: 'Bilim Kurgu' },
    { id: 3, name: 'Fantastik' },
    { id: 4, name: 'Genel Kurgu' },
    { id: 5, name: 'Genç Kurgu' },
    { id: 6, name: 'Gerilim' },
    { id: 7, name: 'Gizem' },
    { id: 8, name: 'Hayran Kurgu' },
    { id: 9, name: 'Klasikler' },
    { id: 10, name: 'Korku' },
    { id: 11, name: 'Kısa Hikaye' },
    { id: 12, name: 'Macera' },
    { id: 13, name: 'Mizah' },
    { id: 14, name: 'Paranormal' },
    { id: 15, name: 'Romantizm' },
    { id: 16, name: 'Spiritüel' },
    { id: 17, name: 'Tarihi Kurgu' },
    { id: 18, name: 'Texting' },
    { id: 19, name: 'Vampir' },
    { id: 20, name: 'Şiir' },
  ];

  // Render either desktop or mobile header based on screen width
  return isMobile ? (
    <MobileHeader 
      userData={userData}
      userId={userId}
      categories={categories}
      navigate={navigate}
    />
  ) : (
    <DesktopHeader 
      userData={userData}
      userId={userId}
      categories={categories}
      handleLogout={handleLogout}
      navigate={navigate}
    />
  );
}

export default HeaderLogIn;
